import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useState } from "react"
import axios from "axios"

const TextAviso = styled.h2`
    text-align: center;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: #a50000;
`
const TextConfirm = styled.p`
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    font-weight: normal;
    color: #333;
`
const BotoesContainer = styled.div`
    width: 100%;
    height: 35px;
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
`
const BotaoConfirm = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #DC2625;
    color: white;
    font-size: 14px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.05;
    }
    font-weight: bold;
`
const BotaoCancelar = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    border: 1px solid rgba(51, 51, 51, 0.4);
    border-radius: 7px;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.05;
    }
    font-weight: bold;
`

const ModelDeleteTipo = ({ item, fetchSuccess, fecharModal }) => {

    const [ loading, setLoading ] = useState( false );

    const handleDelete = async () => {

        setLoading( true );

        try{

            await axios.delete(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/DeleteTipo/index.php?id=${ item.id }`)
            await fetchSuccess?.();
            fecharModal();

        }catch( e ){

            console.error(e);

        }finally{

            setLoading( false );

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="sm" >
                    <TextAviso>Apagar tipo</TextAviso>
                    <TextConfirm>Tem certeza que deseja apagar o tipo { item.nome } ?</TextConfirm>
                    <BotoesContainer>
                        <BotaoCancelar onClick={ fecharModal } >CANCELAR</BotaoCancelar>
                        <BotaoConfirm onClick={ handleDelete } >APAGAR</BotaoConfirm>
                    </BotoesContainer>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModelDeleteTipo;